export default "__VITE_ASSET__rtiuOQMN__"